import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Search, RefreshCw, HelpCircle } from 'lucide-react';

export const NoResultsSection = ({ searchedName, onNewSearch }) => {
  const { t, language } = useLanguage();

  const suggestions = language === 'fr' 
    ? ['Marie', 'Pierre', 'Jean', 'Antoine', 'Thérèse', 'François']
    : ['Mary', 'Peter', 'John', 'Anthony', 'Theresa', 'Francis'];

  return (
    <section className="py-20 bg-gradient-to-b from-background to-secondary/30">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="card-divine text-center">
          <CardContent className="py-12 px-8">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-muted flex items-center justify-center">
              <HelpCircle className="w-10 h-10 text-muted-foreground" />
            </div>
            
            <h2 className="font-heading text-2xl font-semibold text-foreground mb-2">
              {t('results.noResults')}
            </h2>
            
            <p className="text-muted-foreground mb-8">
              {language === 'fr' 
                ? `Nous n'avons pas trouvé de saint pour "${searchedName}". Essayez un autre prénom.`
                : `We couldn't find a saint for "${searchedName}". Try another name.`}
            </p>

            <div className="mb-8">
              <p className="text-sm text-muted-foreground mb-4">
                {language === 'fr' ? 'Suggestions :' : 'Suggestions:'}
              </p>
              <div className="flex flex-wrap justify-center gap-2">
                {suggestions.map((name) => (
                  <button
                    key={name}
                    onClick={() => onNewSearch(name)}
                    className="px-4 py-2 text-sm font-medium text-muted-foreground bg-secondary hover:bg-secondary/80 hover:text-foreground border border-border/50 hover:border-gold/30 rounded-full transition-all duration-300"
                  >
                    {name}
                  </button>
                ))}
              </div>
            </div>

            <Button variant="sacred" size="lg" onClick={() => onNewSearch('')} className="gap-2">
              <RefreshCw className="w-5 h-5" />
              {t('results.tryAnother')}
            </Button>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default NoResultsSection;
